import { all, fork } from "redux-saga/effects";
//layout
import LayoutSaga from "./layouts/saga";
//Auth
import AccountSaga from "./auth/register/saga";
import AuthSaga from "./auth/login/saga";
import ForgetSaga from "./auth/forgetpwd/saga";
import ProfileSaga from "./auth/profile/saga";

//calendar
import calendarSaga from "./calendar/saga";
//chat
import chatSaga from "./chat/saga";

//Project
import projectSaga from "./projects/saga";
// Task
import taskSaga from "./tasks/saga";
// Tasks Saga
import tasksCrmITSaga from "./tasksCrmIT/saga";
// Crypto
import cryptoSaga from "./crypto/saga";
//TicketsList
import ticketsSaga from "./tickets/saga";

//crm
import crmSaga from "./crm/saga";

// CRMit Email Inbox
import EmailInboxSaga from "./CRMitEmailInbox/saga";
// Customers
import CustomersSaga from "./customers/saga";
//jobs list
import jobsSaga from "./jobsList/saga";
// attachment category type
import attachmentCategoryTypeSaga from "./attachmentCategoryType/saga";
// single job saga
import singleJobSaga from "./singleJob/saga";
// staf list
import staffSaga from "./staff/saga";
// demo data

import demoSaga from "./demo/saga";

//invoice
import invoiceSaga from "./invoice/saga";
// invoices
import InvoiceCrmITSaga from "./invoiceCrmIT/saga";
// Calendar
import CalendarCrmITSaga from "./CalendarCrmIT/saga";
// Products
import ProductSagaCrmIT from "./product/saga";
//mailbox
import mailboxSaga from "./mailbox/saga";

// Dashboard Analytics
import dashboardAnalyticsSaga from "./dashboardAnalytics/saga";

// Dashboard CRM
import dashboardCrmSaga from "./dashboardCRM/saga";

//filters
import filtersSaga from "./filters/saga";

// Dashboard Ecommerce
import dashboardEcommerceSaga from "./dashboardEcommerce/saga";

// Dashboard Crypto
import dashboardCryptoSaga from "./dashboardCrypto/saga";

// Dashboard Project
import dashboardProjectSaga from "./dashboardProject/saga";

// Dashboard NFT
import dashboardNFTSaga from "./dashboardNFT/saga";

// Pages > Team
import teamSaga from "./team/saga";

// File Manager
import fileManager from "./fileManager/saga";

// To do
import todos from "./todos/saga";
// Prototyping
import PrototypingSaga from "./Prototyping/saga";
// Time Entries
import TimeEntriesSaga from "./timeEntries/saga";
// Loyalty
import Loyalty from "./loyalty/saga";
// Business Overview
import BusinessOverview from "./businessOverview/saga";
// Navigation Menu
import NavigationMenu from "./navigationMenu/saga";
// Bank
import Bank from "./bank/saga";
// People
import People from "./people/saga";
// Site Search
import SiteSearch from "./siteSearch/saga";
// Advanced Search
import AdvancedSearch from "./advancedSearch/saga";

// Notification Saga
import Notification from "./notification/saga";

//ShortcutApps
import ShortcutApps from "./shortcutApps/saga";

// Products
import Products from "./products/saga";

//Contract
import Contract from "./contract/saga";
// Purchase
import Purchase from "./purchase/saga";
import Supplier from "./supplier/saga";
// Company To User List
import CompanyToUser from "./companyToUser/saga";

// Opportunities
import Opportunities from "./opportunities/saga";
// Quote
import Quote from "./quote/saga";
// Payment Term
import PaymentTerm from "./paymentTerm/saga";
// Master Time Frame Interval
import MasterTimeFrameInterval from "./masterTimeFrameInterval/saga";
// Invoice Items
import InvoiceItems from "./InvoiceItems/saga";
//ContactPersonLookup
import ContactPersonLookup from "./contactPersonLookup/saga";
//PaymentMethod
import PaymentMethod from "./paymentMethod/saga";
// Profit and Loss
import ProfitAndLoss from "./profitAndLoss/saga";
// Charges
import Charges from "./charges/saga";
// Leave Request
import LeaveRequest from "./leaveRequest/saga";
// Dunning
import Dunning from "./dunning/saga";
//ManageLicense
import ManageLicense from "./manageLicense/saga";
//Dashboard
import Dashboard from "./dashboard/saga";
//Recently Viewed
import RecentlyViewed from "./recentlyViewed/saga";
//Liability
import Liability from "./Liability/saga";
//GeneralSettings
import GeneralSettings from "./generalSettings/saga";
//VatPeriodExport
import VatPeriodExport from "./vatPeriodExport/saga";
//YearEndPeriodSaga
import YearEndPeriodSaga from "./YearEndPeriod/saga";
import Security from "./security/saga";
import MasterReporting from "./MasterReporting/saga";
import ReportingDashboard from "./ReportingDashboard/saga";
import CustomerAcquisitionChannel from "./customerAcquisitionChannel/saga";
//Appointment
import Appointment from "./appointment/saga";
import TimeEntriesSummary from "./timeEntriesSummary/saga";
import FoodPreOrderEventsSaga from "./foodPreOederEvent/saga";

//EventSaga
import EventSaga from "./auth/event/saga";
import CompaniesHouseGovUK from "./companiesHouseGovUK/saga";
//BackendAdmin
import BackendAdmin from "./backendAdmin/saga";
//GPS
import GPS from "./GPS/saga";
// Vehicle
import Vehicle from "./vehicle/saga";
// Company Vehicle (fleet)
import CompanyVehicleSaga from "./companyVehicle/saga";
// PdfTemplate (PDF designer)
import PdfTemplateSaga from "./pdfTemplate/saga";
// ESign (e-signing envelopes)
import ESignSaga from "./esign/saga";
// Form Builder (branded forms + submissions)
import FormsSaga from "./forms/saga";
// Company Storage Location
import CompanyStorageLocationSaga from "./companyStorageLocation/saga";
// Asset
import AssetSaga from "./asset/saga";
import StaffContactSaga from "./staffContact/saga";
import SlaSaga from "./sla/saga";
// Gift Voucher (Task 24310)
import GiftVoucherSaga from "./giftVoucher/saga";
// Asset Group
import AssetGroupSaga from "./assetGroup/saga";
// Asset Type
import AssetTypeSaga from "./assetType/saga";
// Asset Status
import AssetStatusSaga from "./assetStatus/saga";
//Checklist
import Checklist from "./checkList/saga";
//Partners
import Partners from "./partners/saga";
//ThirdPartyIntegration
import ThirdPartyIntegration from "./thirdPartyIntegration/saga";
//ProformaInvoice
import ProformaInvoice from "./ProformaInvoice/saga";
//CompanyRecentActivity
import CompanyRecentActivity from "./Company/saga";
//FileUpload
import FileUploads from "./FileUploads/saga";
//Reports
import Reports from "./Reports/saga";
//StaffLeave
import StaffLeave from "./staffLeave/saga";
// feedbackGenSaga
import feedbackGenSaga from "./feedbackGen/saga";
//SalesOrder
import SalesOrder from "./salesOrder/saga";
//MasterPaymentProvider
import MasterPaymentProvider from "./masterPaymentProvider/saga";
//PurchaseOrder
import PurchaseOrder from "./PurchaseOrder/saga";
//ShiftReport
import ShiftReport from "./ShiftReports/saga";
//ChatCrmit
import ChatCrmit from "./ChatCrmit/saga";
//BookATable
import BookATable from "./BookATable/saga";
//FoodTable
import FoodTable from "./FoodTable/saga";
//Wifi (R&D)
import WifiSaga from "./Wifi/saga";
//Serp (rank tracking)
import SerpSaga from "./Serp/saga";
//Meeting AI (notetaker)
import MeetingRecordingSaga from "./MeetingRecording/saga";
//CallInbound (Twilio inbound calls)
import CallInboundSaga from "./CallInbound/saga";
//E-commerce Console (admin)
//MessagingServiceSaga
import MessagingServiceSaga from "./MessagingService/saga";
//PublicPayment
import PublicPayment from "./publicPayment/saga";
import PublicManualPayment from "./publicManualPayment/saga";
import ReportingSaga from "./reporting/saga";
import ReportSavedSaga from "./reportSaved/saga";
import PurchaseDraft from "./PurchaseDraft/saga";
import PaymentRequest from "./PaymentRequests/saga";
//hmrcSaga
import hmrcSaga from "./HMRC/saga";

import DataImportSaga from "./DataImport/saga";
import supplierProductSaga from "./SupplierProduct/saga";
import invoiceDraftSaga from "./InvoiceDraft/saga";
import bomSaga from "./BOM/saga";
import ecommerceSaga from "./ecommerce/saga";
import cronSchedulesSaga from "./cronSchedules/saga";
//socialMediaManagementSaga
import socialMediaManagementSaga from "./socialMediaManagement/saga";
//staffPlanner
import staffPlanner from "./StaffPlanner/saga";
//Leads
import leadsSaga from "./Leads/saga";
import SystemModule from "./Module/saga";
import PosSystemSaga from "./posSystem/saga";
import masterHardwareCatalogSaga from "./Master/saga";
import masterConfigItemSaga from "./masterConfigItem/saga";
import masterThirdPartyPricingSaga from "./masterThirdPartyPricing/saga";
import masterSimSaga from "./masterSim/saga";
import masterSystemServerSaga from "./MasterSystemServer/saga";
import SystemDeviceSaga from "./SystemDevice/saga";
import SystemDeviceHardwareSaga from "./SystemDeviceHardware/saga";
import twilioSaga from "./Twilio/saga";
import smsSaga from "./sms/saga";
import communicationSaga from "./communication/saga";
//DiarySlot
import diarySlotSaga from "./diarySlot/saga";
//DispatchBoard
import dispatchBoardSaga from "./dispatchBoard/saga";
//DiarySlotAssignee
import diarySlotAssigneeSaga from "./diarySlotAssignee/saga";
//JobTimeEntryReport
import jobTimeEntryReportSaga from "./jobTimeEntryReport/saga";
//PlacementRevenueReport
import placementRevenueReportSaga from "./placementRevenueReport/saga";
//FoodPreOrderEventReport
import foodPreOrderEventReportSaga from "./foodPreOrderEventReport/saga";
//Automation
import automationSaga from "./Automation/saga";
//Reviews Centre
import ReviewsSaga from "./Reviews/saga";
//Payroll
import payrollSaga from "./payroll/saga";
//System Wallet (Master DB)
import systemWalletSaga from "./systemWallet/saga";
export default function* rootSaga() {
  yield all([
    //automation
    fork(automationSaga),
    //leads
    fork(leadsSaga),
    fork(PosSystemSaga),
    //public
    fork(LayoutSaga),
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(chatSaga),
    fork(projectSaga),
    fork(taskSaga),
    fork(tasksCrmITSaga),
    fork(cryptoSaga),
    fork(ticketsSaga),
    fork(calendarSaga),

    fork(crmSaga),
    fork(EmailInboxSaga),
    fork(filtersSaga),
    fork(jobsSaga),
    fork(attachmentCategoryTypeSaga),
    fork(singleJobSaga),
    fork(staffSaga),
    fork(CustomersSaga),
    fork(demoSaga),
    fork(invoiceSaga),
    fork(InvoiceCrmITSaga),
    fork(CalendarCrmITSaga),
    fork(ProductSagaCrmIT),
    fork(mailboxSaga),
    fork(dashboardAnalyticsSaga),
    fork(dashboardCrmSaga),
    fork(dashboardEcommerceSaga),
    fork(dashboardCryptoSaga),
    fork(dashboardProjectSaga),
    fork(dashboardNFTSaga),
    fork(teamSaga),
    fork(fileManager),
    fork(todos),
    fork(PrototypingSaga),
    fork(TimeEntriesSaga),
    fork(Loyalty),
    fork(BusinessOverview),
    fork(NavigationMenu),
    fork(Bank),
    fork(People),
    fork(SiteSearch),
    fork(AdvancedSearch),
    fork(Notification),
    fork(ShortcutApps),
    fork(Products),
    fork(Contract),
    fork(Purchase),
    fork(Supplier),
    fork(CompanyToUser),
    fork(Opportunities),
    fork(Quote),
    fork(PaymentTerm),
    fork(MasterTimeFrameInterval),
    fork(InvoiceItems),
    fork(ContactPersonLookup),
    fork(PaymentMethod),
    fork(ProfitAndLoss),
    fork(Charges),
    fork(LeaveRequest),
    fork(Dunning),
    fork(ManageLicense),
    fork(Dashboard),
    fork(RecentlyViewed),
    fork(Liability),
    fork(GeneralSettings),
    fork(VatPeriodExport),
    fork(YearEndPeriodSaga),
    fork(Security),
    fork(MasterReporting),
    fork(ReportingDashboard),
    fork(CustomerAcquisitionChannel),
    fork(Appointment),
    fork(TimeEntriesSummary),
    fork(FoodPreOrderEventsSaga),
    fork(EventSaga),
    fork(CompaniesHouseGovUK),
    fork(BackendAdmin),
    fork(GPS),
    fork(Vehicle),
    fork(CompanyVehicleSaga),
    fork(PdfTemplateSaga),
    fork(ESignSaga),
    fork(FormsSaga),
    fork(CompanyStorageLocationSaga),
    fork(AssetSaga),
    fork(StaffContactSaga),
    fork(SlaSaga),
    fork(GiftVoucherSaga),
    fork(AssetGroupSaga),
    fork(AssetTypeSaga),
    fork(AssetStatusSaga),
    fork(Checklist),
    fork(Partners),
    fork(ThirdPartyIntegration),
    fork(ProformaInvoice),
    fork(CompanyRecentActivity),
    fork(FileUploads),
    fork(Reports),
    fork(StaffLeave),
    fork(feedbackGenSaga),
    fork(SalesOrder),
    fork(MasterPaymentProvider),
    fork(PurchaseOrder),
    fork(ShiftReport),
    fork(ChatCrmit),
    fork(BookATable),
    fork(FoodTable),
    fork(WifiSaga),
    fork(SerpSaga),
    fork(MeetingRecordingSaga),
    fork(CallInboundSaga),
    fork(MessagingServiceSaga),
    fork(PublicPayment),
    fork(PublicManualPayment),
    fork(ReportingSaga),
    fork(ReportSavedSaga),
    fork(PurchaseDraft),
    fork(PaymentRequest),
    fork(hmrcSaga),
    fork(DataImportSaga),
    fork(supplierProductSaga),
    fork(invoiceDraftSaga),
    fork(bomSaga),
    fork(ecommerceSaga),
    fork(cronSchedulesSaga),
    fork(socialMediaManagementSaga),
    fork(staffPlanner),
    fork(SystemModule),
    fork(masterHardwareCatalogSaga),
    fork(masterConfigItemSaga),
    fork(masterThirdPartyPricingSaga),
    fork(masterSimSaga),
    fork(masterSystemServerSaga),
    fork(SystemDeviceSaga),
    fork(SystemDeviceHardwareSaga),
    fork(twilioSaga),
    fork(smsSaga),
    fork(communicationSaga),
    fork(diarySlotSaga),
    fork(dispatchBoardSaga),
    fork(diarySlotAssigneeSaga),
    fork(jobTimeEntryReportSaga),
    fork(placementRevenueReportSaga),
    fork(foodPreOrderEventReportSaga),
    fork(ReviewsSaga),
    fork(payrollSaga),
    fork(systemWalletSaga),
  ]);
}
